module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"discount":"Kondition","productId":"Artikelnummer","quantity":"Menge","title":"Bezeichnung","unit":"Einheit"},"en":{"discount":"Discount","productId":"Product id","quantity":"Quantity","title":"Title","unit":"Unit"}}')
  delete Component.options._Ctor
}
